import React from "react";
import "./SchoolBusStatsCard.css";
import { useTranslation } from "react-i18next";
export default function SchoolBusStatsCard({
  title,
  number,
  icon,
  extraInfo,
  color,
  onClick,
}) {
  const { t } = useTranslation();
  return (
    <div 
      className="sb-card" 
      style={{ 
        backgroundColor: color || 'white',
        cursor: onClick ? 'pointer' : 'default',
      }}
      onClick={onClick}
    >
      <div className="sb-card-header">
        <div className="sb-title-section">
          <div className="sb-icon-container">
            {icon}
          </div>
          <span className="sb-card-title">{t(title)}</span>
        </div>
        <span className="sb-card-number">{number}</span>
      </div>
      {extraInfo && extraInfo.length > 0 && (
        <div className="sb-extra-info">
          {extraInfo.map((info, index) => (
            <div key={index} className="sb-info-item">
              <div className="sb-icon-container">
                {info.icon}
              </div>
              <span className="sb-info-number">{info.number}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
